import { Model, Factory } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import {
  rand,
  randNumber,
  randChanceBoolean,
  randProductName,
} from '@ngneat/falso'

import type { SchemaAttributes } from '../types.js'

type GeneralPrescriptionItem = SchemaAttributes<'GeneralPrescriptionItem'>

export const model = (Model as ModelDefinition<GeneralPrescriptionItem>).extend(
  {},
)

export const factory = Factory.extend<GeneralPrescriptionItem>({
  name() {
    return randProductName()
  },
  type_code() {
    return rand(['MEDICINE', 'FOOD', 'SUPPLY'])
  },
  code() {
    const typeCode = this.type_code as string
    const prefix =
      typeCode === 'MEDICINE' ? 'MED' : typeCode === 'FOOD' ? 'FOOD' : 'SUP'
    return `${prefix}-${randNumber({ min: 1000, max: 9999 })}`
  },
  instructions() {
    return randChanceBoolean({ chanceTrue: 0.7 })
      ? rand([
          'Administer once daily with food',
          'Give twice daily, morning and evening',
          'Apply topically as needed',
          'Administer every 12 hours',
          'Take one tablet twice daily',
        ])
      : null
  },
  quantity() {
    return randChanceBoolean({ chanceTrue: 0.8 })
      ? randNumber({ min: 1, max: 10, precision: 1 })
      : undefined
  },
  refills() {
    return randChanceBoolean({ chanceTrue: 0.6 })
      ? randNumber({ min: 0, max: 5 })
      : undefined
  },
  units() {
    return randChanceBoolean({ chanceTrue: 0.7 })
      ? randNumber({ min: 1, max: 100 })
      : undefined
  },
  unit() {
    return randChanceBoolean({ chanceTrue: 0.7 })
      ? rand(['mg', 'ml', 'tablets', 'capsules', 'g'])
      : null
  },
  package_description() {
    return randChanceBoolean({ chanceTrue: 0.5 })
      ? rand(['Bottle', 'Box', 'Blister pack', 'Container'])
      : null
  },
  dosage_form() {
    return randChanceBoolean({ chanceTrue: 0.6 })
      ? rand(['Tablet', 'Capsule', 'Liquid', 'Topical', 'Injectable'])
      : null
  },
  dosage_units() {
    return randChanceBoolean({ chanceTrue: 0.7 })
      ? randNumber({ min: 1, max: 100 })
      : undefined
  },
  usage_size() {
    return randChanceBoolean({ chanceTrue: 0.6 }) ? rand([1, 2]) : undefined
  },
  withdrawal_periods() {
    return randChanceBoolean({ chanceTrue: 0.4 })
      ? rand([
          'Meat: 7 days, Milk: 3 days',
          'Meat: 14 days, Milk: 5 days',
          'Meat: 21 days, Milk: 7 days',
          'None required',
        ])
      : null
  },
})
